<template>
    <div class="baseCheckBox">
        <span class="icheck" >
            <input type="checkbox" :value="checkvalue" >
        </span>
    </div>
</template>
<script>
export default {
    props: {
        checkvalue: {
            type: String,
            required: true,
        },
        checkcolor:{
            type:String,
            default:'red'
        }
    },    
}
</script>
<style lang="scss" scoped>
.baseCheckBox{
    display: flex;
    align-items: center;
    .icheck{
    margin-right: 7px;
    width: 19px;
    height: 19px;
    background: url(../../assets/imgs/sp_account.png) no-repeat;
    display:inline-block;
    text-indent: -9999px;
    cursor:pointer;
    }
    .red{
        background: url(../../assets/imgs/sp_account.png) no-repeat -30px 0;
    }
    .blue{
        background: url(../../assets/imgs/sp_account.png) no-repeat -78px 0;
    }
    .green{
        background: url(../../assets/imgs/sp_account.png) no-repeat -99px 0;
    }
    .orange{
        background: url(../../assets/imgs/sp_account.png) no-repeat -120px 0;
    }
}
</style>
